import { smoothScroll } from "./modules/_smoothScroll.js";
import { swiperjs } from "./modules/_swiper.js";
import { navInit } from "./modules/_nav.js";
import { badgeRandomizer } from "./modules/_badgeRandomizer.js";
import { comingSoonInit } from "./modules/_comingSoon.js";
import { heroTextInit } from "./modules/_heroText.js";
import { ticketScroll } from "./modules/_ticketScroll.js";
import { speakerInit } from "./modules/_speakerInit.js";
import { starSpawner } from "./modules/_starSpawner.js";
import { speakerStarSpawner } from "./modules/_speakerStarSpawner.js";
import { timeTableInit } from "./modules/_timeTable.js";
import { mapInit } from "./modules/_map.js";

document.addEventListener("DOMContentLoaded", () => {
  smoothScroll();
  swiperjs();
  navInit();
  badgeRandomizer();
  comingSoonInit();
  heroTextInit();
  ticketScroll();
  speakerInit();
  starSpawner();
  speakerStarSpawner();
  timeTableInit();
  mapInit();
});
